import * as React from 'react';
import { IIconSize } from './types';
import { IconWrapper } from './utils';

export const ShieldNegativeFlag = (props: IIconSize) => (
    <IconWrapper {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6061 19.9108C11.8342 20.0299 12.1204 20.0299 12.3485 19.91C18.564 16.6455 19.0054 10.2673 19 8.45372C18.9994 8.30796 18.9553 8.16553 18.8732 8.04388C18.7911 7.92222 18.6744 7.82663 18.5376 7.7688L12.2919 5.06476C12.1925 5.02193 12.085 4.99987 11.9764 5C11.8678 5.00013 11.7604 5.02245 11.6612 5.06552L5.46042 7.77031C5.32559 7.82797 5.21059 7.92235 5.12915 8.04219C5.04771 8.16203 5.00328 8.30226 5.00116 8.44613C4.97478 10.2506 5.34638 16.6424 11.6061 19.9108ZM10.1283 9L9 10.1283L10.8297 11.958L9 13.7876L10.1283 14.9159L11.958 13.0862L13.7876 14.9159L14.9159 13.7876L13.0862 11.958L14.9159 10.1283L13.7876 9L11.958 10.8297L10.1283 9Z"
            fill={props.color}
        />
    </IconWrapper>
);
